import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import hydrogen from '../styles/theme/hydrogen'

const { themes } = hydrogen

const fontAwesomeClass = 'fas'

const options = {
  icons: {
    iconfont: 'faSvg',
    values: {
      complete: `${fontAwesomeClass} fa-circle-check`,
      cancel: `${fontAwesomeClass} fa-circle-xmark`,
      close: `${fontAwesomeClass} fa-xmark`,
      delete: `${fontAwesomeClass} fa-trash`,
      clear: `${fontAwesomeClass} fa-xmark`,
      success: `${fontAwesomeClass} fa-circle-check`,
      info: `${fontAwesomeClass} fa-circle-info`,
      warning: `${fontAwesomeClass} fa-triangle-exclamation`,
      error: `${fontAwesomeClass} fa-circle-xmark`,
      // prev/next removed - using custom Font Awesome components in v-slots instead
      // prev: `${fontAwesomeClass} fa-chevron-left`,
      // next: `${fontAwesomeClass} fa-chevron-right`,
      check: `${fontAwesomeClass} fa-check`,
      checkbox: 'far fa-square',
      checkboxOn: 'far fa-square-check',
      checkboxOff: 'far fa-square',
      checkboxIndeterminate: 'far fa-square-minus',
      delimiter: `${fontAwesomeClass} fa-circle`,
      sort: `${fontAwesomeClass} fa-sort`,
      expand: `${fontAwesomeClass} fa-chevron-down`,
      menu: `${fontAwesomeClass} fa-bars`,
      subgroup: `${fontAwesomeClass} fa-chevron-down`,
      dropdown: `${fontAwesomeClass} fa-caret-down`,
      radioOn: `${fontAwesomeClass} fa-circle-dot`,
      radioOff: `${fontAwesomeClass} fa-circle`,
      edit: `${fontAwesomeClass} fa-pen-to-square`,
      ratingEmpty: `${fontAwesomeClass} fa-star`,
      ratingFull: `${fontAwesomeClass} fa-star`,
      ratingHalf: `${fontAwesomeClass} fa-star-half-stroke`,
      loading: `${fontAwesomeClass} fa-spinner`,
      first: `${fontAwesomeClass} fa-backward-fast`,
      last: `${fontAwesomeClass} fa-forward-fast`,
      unfold: `${fontAwesomeClass} fa-up-down-left-right`,
      file: `${fontAwesomeClass} fa-file`,
    },
  },
  theme: { themes },
}

Vue.use(Vuetify)

export default new Vuetify(options)
